/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Empty/Practice/Content",
  isInvalid,
  onChange
  
}) {
let dentalMonitoringPracticesValueData = fromData.useDataValue({ viewPath,
context: 'dental_monitoring_practices',
})
let selectedPracticeIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'practice_id',
})
let selectedPracticeIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'practice_id',
validate: fromValidate.text,
required: true,
})
let selectedPracticeIdChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'practice_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 size="medium"
 marginLeft={dtSpaceXs}
 maxWidth={240}
 data="dental_monitoring_practices"
 from={dentalMonitoringPracticesValueData}
 data="selected.practice_id"
 validate="/Data/validate.js text"
 invalid={!selectedPracticeIdIsValidData}
 required={true}
 value={selectedPracticeIdValueData}
 onChange={selectedPracticeIdChangeData}
 keepValueUnchanged={true}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Location"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}